import { useCallback } from 'react';
import { useAuth } from './useAuth';

export const usePermissions = () => {
  const { user } = useAuth();

  const hasPermission = useCallback(
    (requiredPermission: string): boolean => {
      if (!user) {
        return false;
      }

      return user.permissions?.includes(requiredPermission) ?? false;
    },
    [user]
  );

  return { hasPermission };
};
